import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/capa/(pages)')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/capa' || location.pathname === '/capa/') {
      throw redirect({ to: '/capa/findings' });
    }
  },
});
